import { PropsWithChildren } from "react";
import { Box, BoxProps } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { WfHeading } from "src/components/base/wf-heading";
import { Bestseller } from "src/components/modules/bestseller-module/bestseller";
import { IBestsellerData } from "src/components/modules/bestseller-module/bestseller.types";
import { TeaserArticle } from "src/components/modules/blog-teaser-module/components/teaser-article";
import { ITeaserArticle } from "src/types/common";

const NewsSidebarHeading = (props: PropsWithChildren) => (
    <WfHeading as="h2" fontSize="2xl" mb="2">
        {props.children}
    </WfHeading>
);

interface INewsSidebarProps extends BoxProps {
    recommendations?: IBestsellerData[];
    magazineTeaser?: ITeaserArticle;
}

const imageStyleProps = {
    borderTopRadius: "8px",
    borderBottomRadius: 0,
};

export const NewsSidebar = (props: INewsSidebarProps) => {
    const { t } = useTranslation(["news"]);
    const { magazineTeaser, recommendations, ...boxProps } = props;

    return (
        <Box {...boxProps}>
            {magazineTeaser && (
                <Box mb="8">
                    <NewsSidebarHeading>{t("headline.magazine")}</NewsSidebarHeading>
                    <TeaserArticle
                        articleData={magazineTeaser}
                        boxShadow="base"
                        borderRadius="8px"
                        bodyBoxProps={{ p: 3 }}
                        imageStyleProps={imageStyleProps}
                    />
                </Box>
            )}
            {recommendations && (
                <Box mb="8">
                    <NewsSidebarHeading>{t("headline.top-wikifolios")}</NewsSidebarHeading>
                    {recommendations.map(item => (
                        <Bestseller data={item} hideChart key={item.id} mb="2" />
                    ))}
                </Box>
            )}
        </Box>
    );
};
